import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export interface PostInitialDraftsRequest {
    engagementId: number;
}

export const PostInitialDrafts = createAsyncThunk(
    'transactionDocuments/postInitialDrafts',
    async (params: PostInitialDraftsRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/InitialDraftsPost`
            );

            if (response.status !== 200) {
                throw new Error('Failed to post the initial document draft package');
            }

            return response.data as TransactionDocuments;
        } catch (error) {
            createNotification('Could not post the initial document draft package.', 'error');
            throw error;
        }
    }
);
